import { useState } from "react"

import './index.scss'

const DeudasFiltros = ({
    handleClickInvertir, handleClickAVencer, handleClickAtrasadas, handleClickVencidas, handleClickSoloJuicios, handleClickPeriodo
}) => {
    const [expanded, setExpanded] = useState(false)

    return (
        <div className="display-row m-top-20">
            <button className="btn task-button float-start m-right-10" onClick={() => setExpanded(x => !x)}>Filtros</button>
            <div className={`deudas-filtros-menu${expanded ? '' : ' hidden'}`}>
                <button className="btn task-button float-start m-right-10" onClick={() => handleClickInvertir()}>Invertir</button>
                <button className="btn task-button float-start m-right-10" onClick={() => handleClickAtrasadas()}>Atrasada</button>
                <button className="btn task-button float-start m-right-10" onClick={() => handleClickAVencer()}>A vencer</button>
                <button className="btn task-button float-start m-right-10" onClick={() => handleClickVencidas()}>Vencida</button>
                <button className="btn task-button float-start m-right-10" onClick={() => handleClickSoloJuicios()}>En juicio</button>
                <button className="btn task-button float-start m-right-10" onClick={() => handleClickPeriodo()}>Período-Cuota</button>
            </div>
        </div>
    )
}

export default DeudasFiltros
